import List from "@/components/list";
import router from "@/router";
import store from "@/store";
import Bus from "./Bus.js";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  const flatPermissions = store.getters.flatPermissions;
  const permissionList = ['periodicalInfo:update', 'periodicalInfo:delete', 'periodicalSubject:list', 'periodicalPeriod:page', 'periodicalInfo:shareList', "periodicalInfo:online"]

  function handleDelete({ row }) {
    Bus.$emit("deleteperiodicalInfo", row);
  }
  function handleUpdate({ row }) {
    router.push({
      path: "/periodicalInfo/edit",
      query: {
        uuid: row.uuid
      }
    });
  }

  function shareManage({ row }) {
    Bus.$emit("shareManage", row.uuid);
  }
  function upLine({ row }) {
    Bus.$emit("upLine", row);
  }
  function downLine({ row }) {
    Bus.$emit("downLine", row);
  }
  function columnManage({ row }) {
    Bus.$emit("columnManage", row.uuid);
  }
  function periodManage({ row }) {
    Bus.$emit("periodManage", row.uuid);
  }
  const Deal = ({ props: { vo } }) => {
    const dealConf = [];
    if (vo.row.enableShared == 0) {
      dealConf.push([
        "icon-edit-disable",
        "编辑",
        () => {},
        "periodicalInfo:update"
      ]);
    } else {
      dealConf.push([
        "icon-edit",
        "编辑",
        () => handleUpdate(vo),
        "periodicalInfo:update"
      ]);
    }
    dealConf.push([
      "icon-delete",
      "删除",
      () => handleDelete(vo),
      "periodicalInfo:delete"
    ]);
    if (vo.row.enableShared == 0) {
      dealConf.push([
        "icon-column-manage-disable",
        "栏目管理",
        () => {},
        "periodicalSubject:list"
      ]);
    } else {
      dealConf.push([
        "icon-column-manage",
        "栏目管理",
        () => columnManage(vo),
        "periodicalSubject:list"
      ]);
    }
    if (vo.row.enableShared == 0) {
      dealConf.push([
        "icon-period-manage-disable",
        "期次管理",
        () => {},
        "periodicalPeriod:page"
      ]);
    } else {
      dealConf.push([
        "icon-period-manage",
        "期次管理",
        () => periodManage(vo),
        "periodicalPeriod:page"
      ]);
    }

    if (vo.row.enableShared == 1) {
      dealConf.push([
        "icon-share",
        "共享管理",
        () => shareManage(vo),
        "periodicalInfo:shareList"
      ]);
    } else {
      dealConf.push([
        "icon-share-none",
        "共享管理",
        () => {},
        "periodicalInfo:shareList"
      ]);
    }

    if (vo.row.onlineStatus == 1) {
      dealConf.push([
        "icon-down",
        "下线",
        () => downLine(vo),
        "periodicalInfo:online"
      ]);
    } else {
      dealConf.push([
        "icon-up",
        "上线",
        () => upLine(vo),
        "periodicalInfo:online"
      ]);
    }
    // v-permission={item[2]}
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const LatestPeriodicalPeriod = ({ props: { vo } }) => {
    return <span>{vo.row.latestPeriodicalPeriod || "--"}</span>;
  };
  const FromDeptName = ({ props: { vo } }) => {
    return <span>{vo.row.fromDeptName || "--"}</span>;
  };
  const ShareDeptName = ({ props: { vo } }) => {
    return <span>{vo.row.shareDeptName || "--"}</span>;
  };

  const PeriodicalName = ({ props: { vo } }) => {
    return (
      <div
        class="base-hover-char"
        onClick={() => {
          router.push({
            path: "/periodicalInfo/detail",
            query: {
              id: vo.row.uuid
            }
          })
        }}
      >
        {vo.row.periodicalName}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "期刊名称",
      minWidth: "240",
      fixed: "left",
      // showOverflowTooltip: true,
      render: vo => <PeriodicalName vo={vo} />
    },
    {
      label: "最新期次",
      prop: "latestPeriodicalPeriod",
      minWidth: "200",
      render: (vo) => <LatestPeriodicalPeriod vo={vo} />,
      showOverflowTooltip: true
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      minWidth: "100"
    },
    {
      label: "版权方",
      prop: "fromDeptName",
      minWidth: "100",
      render: (vo) => <FromDeptName vo={vo} />,
      showOverflowTooltip: true
    },
    {
      label: "已共享学院",
      prop: "shareDeptName",
      minWidth: "100",
      render: (vo) => <ShareDeptName vo={vo} />,
      showOverflowTooltip: true
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: "150",
      showOverflowTooltip: true
    },
  ];
  let iconNum = 0;
  permissionList.forEach(x => {
    if (flatPermissions.includes(x)) {
      iconNum += 1;
    }
  });
  if (iconNum > 0) {
    AccountTableConfig.push({
      label: "操作",
      fixed: "right",
      width: String(iconNum * 30 + 10 > 130 ? 130 : iconNum * 30 + 10),
      render: vo => <Deal vo={vo} />
    })
  }
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
